import { defineResource } from 'pulse/resources';
import { defaultHubSettingResolver } from './resolver';
export const HubSetting = defineResource({
  typeName: 'hs-resources:HubSetting',
  resolver: defaultHubSettingResolver,
  args: ['settingName']
}).register();